import SelectAllButton from './selectAllButton.container';

export default SelectAllButton